// Возвращает "тело" токена для БД (без префикса ENTRY_),
// либо null если в строке нет токена.
export function extractToken(input?: string | null): string | null {
  if (!input) return null;
  const s = String(input).trim();

  // Варианты:
  // - "ENTRY_xxx"
  // - "...?start=ENTRY_xxx" (deeplink)
  // - просто "xxx" (уже тело)
  const m =
    s.match(/ENTRY_([A-Za-z0-9_-]+)/) ||
    s.match(/[?&]start=ENTRY_([A-Za-z0-9_-]+)/) ||
    s.match(/^([A-Za-z0-9_-]{10,})$/);

  if (!m) return null;
  const body = m[1] || m[0];

  // Мини-проверка на валидный набор символов
  return /^[A-Za-z0-9_-]{10,}$/.test(body) ? body : null;
}